import * as React from "react";

import "./shipping-addresses-panel.scss";

import {cs}            from "@Common/react/chain-services";
import {Load2}         from "@Common/react/load2";
import {BubbleNoti}    from "@Common/ui-components/bubble-noti/bubble-noti";
import {Badge}         from "@Common/ui-components/heavy/common/design2/badge/badge";
import {ConfirmDialog} from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";

import {ItemGrid1} from "../item-grid-1/item-grid-1";

import {AddShippingAddressModal}  from "./modals/add-shipping-address-modal/add-shipping-address-modal";
import {EditShippingAddressModal} from "./modals/edit-shipping-address-modal/edit-shipping-address-modal";

export const ShippingAddressesPanel = ({apis: apis1}) => cs(
    ["addresses", ({}, next) => Load2({
        fetch: () => apis1.getList(),
        next,
    })],

    ["addModal", (_, next) => AddShippingAddressModal({apiAdd: apis1.add, next})],
    ["editModal", (_, next) => EditShippingAddressModal({next})],
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    ["bubbleNoti", (_, next) => BubbleNoti({next})],
    ({addresses, bubbleNoti, addModal, editModal, confirmDialog}) => ItemGrid1({
        height: 190,
        placeholder: {
            message: "You can add, edit, and delete addresses for future orders.",
            action: {
                label: "ADD NEW ADDRESS",
                onClick: () => {
                    addModal.show({
                        lockedAsDefault: addresses.value.length === 0,
                        onDone: async (address) => {
                            addresses.onChange([
                                address,
                                ...addresses.value,
                            ]);

                            bubbleNoti.show({
                                message: "Success! Shipping address successfully added.",
                                color: "green",
                            });
                            await addresses.reload();
                        }
                    });
                },
            }
        },
        items: addresses.value?.map((a, i) => ({
            key: a.idPrimary,
            render: () => (
                <div className="shipping-addresses-panel-9wi card" xd-qa-type="card" xd-qa-name={a.contactName}>
                    <div className="line1">
                        <div className="left">
                            <div className="contact-name" title={a.contactName} xd-qa-type="text" xd-qa-name={a.contactName}>
                                {a.contactName}
                            </div>
                            <div className="company" title={a.company} xd-qa-type="text" xd-qa-name={a.company}>
                                {a.company}
                            </div>
                        </div>

                        <div className="right">
                            {a.defaultBranch && (
                                Badge({
                                    color: "blue-inverse",
                                    text: "Default",
                                    xdQaName: "Default",
                                })
                            )}

                            <div className="action-links">
                                <a {...{
                                    onClick: () => {

                                        editModal.show({
                                            lockedAsDefault: a.defaultBranch,
                                            address: a,
                                            onDone: async (address) => {
                                                addresses.change((_) => _.map((a) => a.idPrimary !== address.idPrimary ? a : address));

                                                bubbleNoti.show({
                                                    message: "Success! Shipping address successfully changed.",
                                                    color: "green",
                                                });
                                                await addresses.reload();
                                            }
                                        });
                                    },
                                }}
                                    xd-qa-type="link"
                                    xd-qa-name="Edit"
                                >
                                    Edit
                                </a>
                                <a {...{
                                    onClick: async () => {
                                        const confirmed = await confirmDialog.show({
                                            actionName: "remove",
                                            message: "This will remove address " + a.contactName,
                                        });
                                        if (confirmed) {
                                            addresses.change((_) => _.filter((a1) => a1 !== a));
                                            await apis1.deleteShippingAddress(a.idPrimary);

                                            bubbleNoti.show({
                                                message: "Success! Shipping address successfully removed.",
                                                color: "green",
                                            });
                                            await addresses.reload();
                                        }
                                    },
                                }}
                                    xd-qa-type="link"
                                    xd-qa-name="Remove"
                                >
                                    Remove
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="details-train">
                        <div className="car">
                            <div className="label" xd-qa-type="label" xd-qa-name="Address">
                                Address
                            </div>
                            {
                                formattedAddress(a)
                            }
                        </div>
                    </div>
                </div>
            ),
        })),
    }),
);

const formattedAddress = (address) => {    
    return (
        <div className="value">
            <div className="address" xd-qa-type="text" xd-qa-name="Address 1">
                {address.address1},
            </div>
            {
                address.address2 &&
                <div className="address" xd-qa-type="text" xd-qa-name="Address 2">
                    {address.address2},
                </div>
            }
            <div className="address" xd-qa-type="text" xd-qa-name="City State Zip">
                {`${address.city}, ${address.state} ${address.postalCode}`}
            </div>
            <div className="phone" xd-qa-type="text" xd-qa-name="Phone">
                {address.contactPhone}
            </div>
        </div>
    )
}